module.exports = __webpack_public_path__ + "media/images/frontend/yellow-21882b0bc524f9f9e383c5aa221fd152.png";